export function reduceByKey(subject, callbackfn, initialValue) {
    return Object.keys(subject).reduce((p, k, i, a) => callbackfn(p, k, i, a, subject), initialValue);
}
/**
 * @deprecated renamed to reduceByKey
 */
export const reduceKey = reduceByKey;
//# sourceMappingURL=reduceKey.js.map